import Vue from 'vue'
import VueRouter from 'vue-router'
import SplashScreen from '@puzzleapps/crossword/src/views/SplashScreen'
import Archive from '@puzzleapps/shared/src/views/Archive3'
import Game from '@puzzleapps/crossword/src/views/Game'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: SplashScreen,
    props: {
      default: true,
      logoComponent: 'Crossword',
      hasdifficulty: false,
      hasArchive: true,
    }
  },
  {
    path: '/game/',
    name: 'Game',
    component: Game,
  },
  {
    path: '/archive',
    name: 'Archive',
    component: Archive,
  }
]

const router = new VueRouter({
  routes,
  mode: 'abstract'
})

router.replace('/')

export default router
